import { FileInputProps, FormLabel } from '@mi-front/ui';
import CheckIcon from '@mui/icons-material/Check';
import DeleteIcon from '@mui/icons-material/Delete';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Box, Button, Chip, FormHelperText } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';
import { UploadAssetMui } from './UploadAssetMui';

interface Props {
  name: string;
  label?: string;
  successText?: string;
  inputProps?: Partial<FileInputProps>;
  assetLink?: boolean;
}

export function UploadAssetFieldMui(p: Props) {
  const { control } = useFormContext();
  const { $t } = useIntl();

  return (
    <Box>
      {p.label && <FormLabel>{p.label}</FormLabel>}
      <Controller
        name={p.name}
        control={control}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <>
            <Box display={'flex'} alignItems={'center'} gap={2}>
              {value && (
                <Chip
                  variant={'outlined'}
                  icon={<CheckIcon fontSize={'small'} />}
                  label={
                    p.successText ||
                    $t({
                      id: 'assets.fileUploaded',
                      defaultMessage: 'Archivo cargado',
                    })
                  }
                  size="small"
                  onDelete={() => onChange(null)}
                  deleteIcon={<DeleteIcon />}
                />
              )}
              {!value && (
                <UploadAssetMui
                  inputProps={p.inputProps}
                  onUploaded={(url) => {
                    onChange(url);
                  }}
                />
              )}
              {value && p.assetLink && (
                <Button
                  size="small"
                  href={value}
                  target="_blank"
                  rel="noopener noreferrer"
                  startIcon={<OpenInNewIcon />}
                  sx={{ mr: 2 }}
                >
                  {$t({ id: 'assets.viewFile', defaultMessage: 'View file' })}
                </Button>
              )}
            </Box>
            {error && <FormHelperText error>{error.message}</FormHelperText>}
          </>
        )}
      />
    </Box>
  );
}
